import GatewayTable from "./GatewayTable.tsx";
import DescriptionBox from "../../../components/DescriptionBox/index.tsx";

const APIGateway = () => {
  return (
    <GatewayTable
      header={
        <DescriptionBox
          title="API Gateway"
          subTitle="Gateway Load Monitoring"
          description="Real-time connectivity and health status of API gateways across all store locations."
        />
      }
    />
  );
};

export default APIGateway;
